import { useMemo } from 'react';
import _ from 'lodash';

import useHealthPlanSpendTrackerStore from '@/modules/deductibles/HealthPlanDetails/stores/useHealthPlanSpendTracker.store.ts';

import { HealthPlanDeductibleConfig } from '../../deductibles.types';
import { useGetProcessingRuleByIdQuery } from '../queries';
import { useHealthPlanByIdQuery } from '../queries';
import { useServiceConfigs } from '../queries';

const useTiersModule = () => {
  const coverageLevel = useHealthPlanSpendTrackerStore((state) => state.state.coverageLevel);
  const healthPlanId = useHealthPlanSpendTrackerStore((state) => state.state.healthPlanId);
  const { data: healthPlan, isLoading: isHealthPlanLoading } = useHealthPlanByIdQuery(healthPlanId);
  const { data: serviceConfigs, isLoading: isServiceLoading } = useServiceConfigs(healthPlanId);

  const planStatus = useMemo(() => healthPlan?.plan_status, [healthPlan]);
  const processingRuleId = useMemo(
    () => _.toString(healthPlan?.enrollment_matrix?.processing_rule_id),
    [healthPlan]
  );
  const healthPlanDeductibleConfig = useMemo(
    () =>
      (healthPlan?.health_plan_deductible_configs as unknown as HealthPlanDeductibleConfig[])?.find(
        (el) => el.coverage?.name === coverageLevel
      ),
    [coverageLevel, healthPlan?.health_plan_deductible_configs]
  );
  const { rule, isLoading } = useGetProcessingRuleByIdQuery(processingRuleId);

  const triggerAmounts = useMemo<Record<string, number>>(() => {
    const amounts: Record<string, number> = {};
    healthPlanDeductibleConfig?.trigger_configs?.forEach((tc) => {
      if (tc.trigger_id != null && tc.threshold_amount != null) {
        amounts[`${tc.trigger_id}`] = tc.threshold_amount;
      }
    });
    return amounts;
  }, [healthPlanDeductibleConfig]);

  const isLoadingAll = useMemo(
    () => isHealthPlanLoading || isServiceLoading || isLoading,
    [isHealthPlanLoading, isServiceLoading, isLoading]
  );

  return {
    isLoadingAll,
    planStatus,
    serviceConfigs,
    rule,
    triggerAmounts,
  };
};

export default useTiersModule;
